import { MetricTypes } from '@spotify-internal/semantic-metrics';
import { defaultTags, MetricActions, sendMetric } from './utils/metricsHelper';
import { getLoginUrl } from './getLoginUrl';
const interactiveLogin = (authServerConfig, clientConfig, loginParameters) => {
    sendMetric({
        metric_type: MetricTypes.COUNTER,
        what: MetricActions.INTERACTIVE_LOGIN,
        value: 1,
        tags: Object.assign({ serverUrl: authServerConfig.url }, defaultTags),
    });
    window.location.href = getLoginUrl(authServerConfig, clientConfig, loginParameters);
};
export { interactiveLogin };
//# sourceMappingURL=login.js.map